/** Spoken radiotelephony forms for TTS. A spoken line must normalise (rubric.js normalizeTranscript) to the same tokens as its display text. */
export const DIGIT_WORDS = Object.freeze(['zero','one','two','three','four','five','six','seven','eight','nine']);
export const WAYPOINT_ALIASES = Object.freeze([
  Object.freeze({ id: 'ABDR', key: 'abdr', aliases: Object.freeze(['ABDR', 'Aberdeen Reservoir', 'Alpha Bravo Delta Romeo', 'A B D R']) }),
  Object.freeze({ id: 'ICC', key: 'icc', aliases: Object.freeze(['ICC', 'ICC International Commerce Centre', 'International Commerce Centre', 'India Charlie Charlie', 'I C C']) }),
  Object.freeze({ id: 'Happy Valley', key: 'happy valley', aliases: Object.freeze(['Happy Valley', 'Happy Valley Racecourse']) }),
  Object.freeze({ id: 'Shing Mun River', key: 'shing mun river', aliases: Object.freeze(['Shing Mun River']) }),
  Object.freeze({ id: 'Tai Lam Chung Reservoir', key: 'tai lam chung reservoir', aliases: Object.freeze(['Tai Lam Chung Reservoir']) }),
  Object.freeze({ id: 'HKCEC', key: 'hkcec', aliases: Object.freeze(['Hong Kong Convention and Exhibition Centre', 'HKCEC', 'Hotel Kilo Charlie Echo Charlie', 'H K C E C']) }),
]);
const SIDE_WORDS = Object.freeze({ L: 'left', R: 'right', C: 'center' });

export function spokenDigits(digits) {
  return String(digits).replace(/\D/g, '').split('').map((digit) => DIGIT_WORDS[Number(digit)]).join(' ');
}

export function spokenAltitude(value) {
  const feet = Number(value);
  if (!Number.isInteger(feet) || feet < 1000 || feet % 100) return spokenDigits(value);
  const thousands = spokenDigits(Math.floor(feet / 1000));
  const hundreds = Math.floor((feet % 1000) / 100);
  return hundreds ? `${thousands} thousand ${DIGIT_WORDS[hundreds]} hundred` : `${thousands} thousand`;
}

export function spokenRadiotelephony(text) {
  return String(text ?? '')
    .replace(/\b(Runway|runway|RUNWAY)\s+(\d{1,2})([LRC])?\b/g, (_, word, num, side) => `${word} ${spokenDigits(num.padStart(2, '0'))}${side ? ` ${SIDE_WORDS[side]}` : ''}`)
    .replace(/\b(\d{3})\.(\d{1,3})\b/g, (_, whole, part) => `${spokenDigits(whole)} decimal ${spokenDigits(part)}`)
    .replace(/\b(wind)\s+(\d{3})\s+(at)\s+(\d{1,2})\s+(knots)\b/gi, (_, wind, direction, at, speed, knots) => `${wind} ${spokenDigits(direction)} ${at} ${spokenDigits(speed)} ${knots}`)
    .replace(/\b(heading)\s+(\d{1,3})\b/gi, (_, heading, value) => `${heading} ${spokenDigits(value.padStart(3, '0'))}`)
    .replace(/\b(maintain)\s+(\d{3,5})\b/gi, (_, maintain, value) => `${maintain} ${spokenAltitude(value)}`)
    .replace(/\b(Starwalker)\s+(\d{1,4})\b/g, (_, callsign, num) => `${callsign} ${spokenDigits(num)}`)
    .replace(/\b(number)\s+(\d)\b/gi, (_, label, digit) => `${label} ${DIGIT_WORDS[Number(digit)]}`);
}

export function atcSpokenFor(turn) {
  return turn?.atcSpoken || spokenRadiotelephony(turn?.atcText ?? '');
}
